export default __webpack_public_path__ + "static/alina-kupchyk-e99aff5fb7a3833e8692b64981ded7ad.png";